import { ContentWidthEnum } from 'common/types/styleTypes'
import { backgroundCss, mobileBackgroundCss } from 'common/utils/styleUtilsNew'
import { contentWidthValues } from 'src/shared/constants/content-width-values'
import { css, styled } from 'styled-components'

export interface WebsitePageBodyContainerProps {
  background: string | undefined
  contentWidth: ContentWidthEnum | undefined
}

export const WebsitePageBodyContainer = styled.div<WebsitePageBodyContainerProps>`
  /** ------------------------------------------------------------
    * NOTE: this hack prevent margin collapsing
    * https://app.shortcut.com/systeme/story/74716/margin-affects-website-content
    * https://habr.com/ru/articles/257327/ */
    border: solid transparent;
    border-width: 1px 0;
  /* ------------------------------------------------------------ */
  ${p =>
    p.contentWidth &&
    css`
      max-width: ${contentWidthValues[p.contentWidth]};
      margin: 0 auto;
    `}

  ${backgroundCss}

`
